/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = {
  muc1: [
    {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
    },
  ],
  muc2: [
    {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
    },
  ],
  muc3: [
    {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
    },
  ],
};

export default function TaxPersonalTable03({ formData, setFieldValue, count }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleAdd = (rowType) => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
    };
    setData((prev) => ({ ...prev, [rowType]: [...prev[rowType], newRow] }));
  };

  const handleDelete = (id, rowType) =>
    setData((prev) => ({ ...prev, [rowType]: prev[rowType].filter((item) => item.id !== id) }));

  const handleChange = (values) => {
    console.log({ values });
    const { id, name, value, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType].map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h5">
        C. KÊ KHAI THUẾ/PHÍ BẢO VỆ MÔI TRƯỜNG HOẶC THUẾ TÀI NGUYÊN
      </Typography>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", width: 10 }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Tài nguyên, hàng hóa, sản phẩm
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Đơn vị tính
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Sản lượng, số lượng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Giá tính thuế tài nguyên / mức thuế hoặc phí BVMT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Thuế suất
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số thuế
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (5)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (6)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (7)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (8)
              </Td>
            </tr>

            <tr>
              <Td
                className="toggle-button"
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              >
                1
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc1")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                rowSpan={1}
                colSpan={6}
                style={{ textAlign: "left", fontWeight: 900, background: "#ddeff3" }}
              >
                Khai thuế tài nguyên
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              >
                (8)=(5)*(6)*(7)
              </Td>
            </tr>
            {data.muc1.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  1.{index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id, "muc1")}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "left" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value2", value: e.target.value })
                    }
                  >
                    <option value="value1">value1</option>
                    <option value="value1">value1</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc1"
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc1"
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              </tr>
            ))}
            <tr>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              ></Td>
              <Td rowSpan={1} style={{ textAlign: "left", fontWeight: 900, background: "#ddeff3" }}>
                Tổng cộng
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              >
                [{count + 2}]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
            </tr>

            <tr>
              <Td
                className="toggle-button"
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              >
                1
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc2")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                rowSpan={1}
                colSpan={6}
                style={{ textAlign: "left", fontWeight: 900, background: "#ddeff3" }}
              >
                Khai thuế bảo vệ môi trường
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              >
                (8)=(5)*(6)
              </Td>
            </tr>
            {data.muc2.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  2.{index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id, "muc2")}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "left" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value2", value: e.target.value })
                    }
                  >
                    <option value="value1">value1</option>
                    <option value="value1">value1</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc1"
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc1"
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              </tr>
            ))}
            <tr>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              ></Td>
              <Td rowSpan={1} style={{ textAlign: "left", fontWeight: 900, background: "#ddeff3" }}>
                Tổng cộng
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              >
                [{count + 3}]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
            </tr>

            <tr>
              <Td
                className="toggle-button"
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              >
                1
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc3")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                rowSpan={1}
                colSpan={6}
                style={{ textAlign: "left", fontWeight: 900, background: "#ddeff3" }}
              >
                Khai phí bảo vệ môi trường
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              >
                (8)=(5)*(6)
              </Td>
            </tr>
            {data.muc3.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  3.{index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id, "muc3")}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "left" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value2", value: e.target.value })
                    }
                  >
                    <option value="value1">value1</option>
                    <option value="value1">value1</option>
                  </select>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc1"
                    id={item.id}
                    name="value5"
                    value={item.value5}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    rowType="muc1"
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}></Td>
              </tr>
            ))}
            <tr>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              ></Td>
              <Td rowSpan={1} style={{ textAlign: "left", fontWeight: 900, background: "#ddeff3" }}>
                Tổng cộng
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", fontWeight: 900, background: "#ddeff3" }}
              >
                [{count + 4}]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}></Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, id, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name, id, rowType });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
